// StripeElementsWrapper.js
import React, { useEffect } from 'react';
import { useLocation } from "react-router-dom";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Puff } from 'react-loader-spinner';
import PurchaseCreditsPayments from './PurchaseCreditsPayments';
import { useDispatch, useSelector } from "react-redux";
import CheckoutForm from './PurchaseCreditsPayments';
import { getStoredValue } from '../../_helpers/storagehelper';
// const stripePromise = loadStripe('pk_test_51QIlNVBrP5Qki2SsFpsHdX7DAvWvAd6RBrGn4ABO3EsTzRo6KKUx32eW0AVTjCyGvxpFjNtK2dFDeNf7lk0fnYqg00W3AgxJto')
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const StripeElementsWrapper = () => {
  //   const clientSecret = useSelector((state) => state.purchaseCredits.CreateClientSecretDetails);
  //  if (!clientSecret) return <div>Loading...</div>;
  // const clientSecretID = clientSecret.clientSecretID


  const location = useLocation();
  const { clientSecret, stripeRandomOrderID, totalAmount, processingFee } = location.state || {};
  const storedLang = getStoredValue("lang");

  // Browser Back Button Issue Solved 
  const authUser = useSelector((state) => state);
  const { token } = useSelector((state) => state.auth);
  // Function used for If token is not null or undefined means not allow to show login page
  useEffect(() => {
    if (token && !authUser?.auth?.user) {
      window.history.forward();
      //  navigate(from, { replace: true }); // Redirect to the original page or '/dashboard'
    }
  }, [token]);

  return (
    <div>
      <Elements stripe={stripePromise} options={{ clientSecret, locale: storedLang ? storedLang : "en" }}>
        <PurchaseCreditsPayments stripeRandomOrderID={{ stripeRandomOrderID }} totalAmount={{ totalAmount }} processingFee={processingFee} />
      </Elements>
    </div>
  );
};

export default React.memo(StripeElementsWrapper);